import React from 'react'

import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import EditorService from 'live/services/editor'
import { DEFAULT_CHART_CONFIG as TEMPORAL_DEFAULT_CHART_CONFIG } from 'live/widgets/temporal'
import i18n from 'live/services/i18n'

import {
    addWidgetEditorToMenu,
    DEFAULT_CHANNELS_CHART_CONFIG,
    DEFAULT_CHANNELS_CHART_POLICIES
} from 'plugin-assets/shared/widget/lib/util'
import { DashboardWidgetActionsTemporal as WidgetViewActions } from 'plugin-assets/shared/widget/multi-channel/configs/ViewMode'
import WidgetEditActions from 'plugin-assets/shared/widget/multi-channel/configs/EditMode'

import {
    DataNavigationMessage,
    DataNavigationState
} from 'plugin-live-exploratory-viz/src/data-navigation/types/widget'
import { reducer } from 'plugin-live-exploratory-viz/src/data-navigation/reducer'
import { widgetType } from 'plugin-live-exploratory-viz/src/data-navigation/constants'
import { withSuspenseWrapper } from 'plugin-live-exploratory-viz/components/SuspenseWrapper'

const DataNavigationWidgetWrapper = reactWidgetWrapper<DataNavigationState, DataNavigationMessage>(
    withSuspenseWrapper(React.lazy(() => import('plugin-live-exploratory-viz/src/data-navigation/component/Widget'))),
    reducer
)

const EditorInfo = {
    order: -10,
    type: 'data-navigation-editor',
    label: i18n('Span control widget'),
    description: i18n('Control the span to filter data'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: WidgetEditActions,
    defaultWidgetType: widgetType
})

const DATA_NAVIGATION_POLICIES = {
    ...DEFAULT_CHANNELS_CHART_POLICIES,
    renderOwnAxis: false
    // preventReloadOnParamsChange: true
}

const DATA_NAVIGATION_CONFIG: Partial<LiveWidgetConfig> = {
    ...TEMPORAL_DEFAULT_CHART_CONFIG,
    ...DEFAULT_CHANNELS_CHART_CONFIG,
    span: 'last 24 hours',
    // spanFinal: true,
    kind: widgetType
}

widgetService.register({
    type: widgetType,
    name: widgetType,
    config: DATA_NAVIGATION_CONFIG,
    policies: DATA_NAVIGATION_POLICIES,
    description: i18n('A widget that perform data navigation by time span'),
    impl: DataNavigationWidgetWrapper
    // ui: {
    //     editor: EditorInfo.type
    // }
    // dashboardActions: {
    //     mode: 'view',
    //     component: WidgetViewActions
    // }
})

// Widget UI config on view-mode
widgetService.dashboardActions(widgetType, 'view', WidgetViewActions)
// Widget UI config on edit-mode
widgetService.editor(widgetType, EditorInfo.type)
// Avoid to show this widget on query based charts(Pipes charts creation)
widgetService.ui(widgetType, { editor: EditorInfo.type })

widgetService.queryHandlerKind(widgetType, widgetType)

addWidgetEditorToMenu({
    ...EditorInfo,
    thumbnail: require('../../assets/widget-span-control-temporal-thumb.png').default,
    tags: ['assets', 'channels', 'time-based']
})
